import React, { useState } from 'react';
import ProfileTitle from './ProfileTitle';

type Props = {
  src: string;
  index?: number;
};

const Selfie = ({ src, index }: Props) => {
  const [isPersonalDetailHidden, setIsPersonalDetailHidden] = useState(false);

  return (
    <div className="selfie">
      <ProfileTitle name="Selfie" index={index} onClick={() => setIsPersonalDetailHidden(!isPersonalDetailHidden)} />
      {isPersonalDetailHidden && (
        <img
          src={src}
          alt="selfie"
        />
      )}
    </div>
  );
};

export default Selfie;
